import video from "../../assets/video/home.mp4";
import video_fmps from "../../assets/video/home_fmps.mp4";
import logo_laraki from "../../assets/img/logo_laraki.png";
import home_laraki from "../../assets/img/home_laraki.png";


export const videos = {
  video, video_fmps, logo_laraki, home_laraki
};
